export default __webpack_public_path__ + "static/media/higher_icon_network_reversed.4168369a.svg";